<template>
	<div class="goods_group_label_box" v-if="storeToken&&returnLabelArray.length>0">
		<template v-for="(item,index) in returnLabelArray">
			<el-tag size="mini" type="error" :style="item.style">{{ item.text }}</el-tag>
		</template>
    </div>
</template>
<script>

export default {
	name: "goods-group-label",

	props: {
		goods: {
			type: Object,
			required: true,
			default: ''
		}
	},
	data() {
		return {}
	},
	methods: {
	},
	computed: {
		storeToken() {
			return this.$store.state.member.token;
		},
		returnLabelArray(){
			let labelArray = [];
			let defaultStyle = 'border:none;display:flex;line-height: 22px;';
			if(this.goods.goods_label!=undefined&&this.goods.goods_label!=''&&this.goods.goods_label!=null&&this.goods.goods_label.length>0){
				labelArray = this.goods.goods_label.map(item=>{
					let newItem = {
						text:item.label_name,
						style:`background-color: ${item.label_color};color: ${item.font_color};${defaultStyle}`
					};
					return newItem;
				})
			}
			return labelArray;
		}
	}
}
</script>

<style scoped lang="scss">
.goods_group_label_box{
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 6px;
}
</style>
